var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('poster-dragger',{attrs:{"editable":_vm.editable,"reason":_vm.reason,"dirty":_vm.dirty},on:{"reset":_vm.resetAll,"dirty":_vm.makeDirty}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }